import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  getNegociacoes(medicoId) {
    return api.get(`/medico/${medicoId}/negociacoes`)
  },
}
